(function () {
if (!customElements.get("lsg-video")) customElements.define("lsg-video", class LSGVideo extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            playToggle: ".js-lsg-video-play",
            video: ".js-lsg-video"
        };
        this.playToggle = this.querySelectorAll(this.selectors.playToggle);
        this.video = this.querySelector(this.selectors.video);
        this.init();
    }
    init() {
        const videoElem = this.video;
        async function playVideo() {
            try {
                await videoElem.play();
            } catch (err) {}
        }
        this.playToggle.forEach((el)=>{
            el.addEventListener("click", ()=>{
                playVideo();
                el.classList.add("is-playing");
            });
        });
    }
});

})();
